import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { storeToRefs } from 'pinia';
import { useMessageCenterStore } from '@/store';
import Sidebar from 'primevue/sidebar';


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageCenterBase',
  setup(__props) {

const messageCenter = useMessageCenterStore();
const { visible } = storeToRefs(messageCenter);

function closeSidebar() {
  messageCenter.visible = false;
  messageCenter.currentChatId = undefined;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Sidebar), {
    visible: _unref(visible),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    position: "right",
    modal: false,
    dismissable: false,
    class: "messages-sidebar m-2 border-round-lg shadow-lg",
    onHide: closeSidebar
  }, {
    header: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header")
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["visible"]))
}
}

})